// extracted by mini-css-extract-plugin
export default {"root":"bozEq","collapsed":"_1njTF"};